import React, { useEffect, useState } from "react";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import { tooltips } from "../popData";
import FooterBtn from "./FooterBtn";

const CloneOptions = ({ inEditMode, clone }) => {
  // Options for cloning in footer
  const [cloneOptions, toggleCloneOptions] = useState(false);

  useEffect(() => {
    // Hide clone options whenever edit mode it toggled.
    toggleCloneOptions(false);
  }, [inEditMode]);

  return (
    <div title={tooltips.clone}>
      {cloneOptions && (
        <div className="clone-options">
          <button
            data-clonetype="customer"
            onClick={clone}
            className="c-option"
          >
            Customer
          </button>
          <button data-clonetype="all" onClick={clone} className="c-option">
            All
          </button>
        </div>
      )}
      <FooterBtn
        cb={() => toggleCloneOptions((pS) => !pS)}
        isActive={cloneOptions}
      >
        <FileCopyIcon style={{ fontSize: 28 }} />
      </FooterBtn>
    </div>
  );
};

export default CloneOptions;
